import { useMutation } from 'react-query'
import { useDispatch, useStore } from 'react-redux'

import {
  type IStateWithGlobal,
  makeSelectSystemPreferences,
  updateGlobal,
} from '@webapp/core/stores/global'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { catalogAccessRepository } from '@webapp/modules/purchasing/data-access/repositories/CatalogAccessRepository'

export const useToggleCatalogLockDefaultModel = () => {
  const dispatch = useDispatch()
  const store = useStore()

  const { mutateAsync: setCatalogLockDefault, isLoading } = useMutation<
    boolean,
    RepoError,
    boolean
  >({
    mutationFn: (value: boolean) =>
      catalogAccessRepository.setRfoLockDefault(value),
    // `rfo_lock_default` lives in the global system-preferences store, which the
    // get-settings model reads. Read the freshest snapshot at dispatch time (via
    // the store, not a render-closure) so a concurrent preference write isn't
    // clobbered when the reducer replaces the whole `systemPreferences` object.
    onSuccess: (serverValue) => {
      const systemPreferences = makeSelectSystemPreferences()(
        store.getState() as IStateWithGlobal
      )

      dispatch(
        updateGlobal({
          systemPreferences: {
            ...systemPreferences,
            rfo_lock_default: serverValue,
          },
        })
      )
    },
  })

  return { setCatalogLockDefault, isLoading }
}
